import { axiosAuthInstance } from "../config/axios-config";
import { getCommunityId } from "../store/communities.store";

const communityId = getCommunityId();
// console.log(communityId);

var UserService = {
  getUserBySocialId: async function (input) {
    return await axiosAuthInstance
      .get("/users/find", {
        params: {
          socialId: input.socialId,
        },
      })
      .then((res) => {
        return res.data;
      });
  },
  getUserByEmail: async function (input) {
    return await axiosAuthInstance
      .get("/users/find", {
        params: {
          email: input.email,
        },
      })
      .then((res) => {
        return res.data;
      });
  },
  getUserByUserName: async function (input) {
    return await axiosAuthInstance
      .get("/users/find", {
        params: {
          username: input.username,
        },
      })
      .then((res) => {
        return res.data;
      });
  },

  findUser: async function (input) {
    return await axiosAuthInstance
      .get("/users/find", {
        params: {
          ...input,
        },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return err;
      });
  },

  getUsers: async function (input) {
    return await axiosAuthInstance
      .get("/users", { params: { ...input } })
      .then((res) => {
        return res.data;
      });
  },

  getUsersData: async function () {
    return await axiosAuthInstance.get("/users/me").then((res) => {
      return res.data;
    });
  },
  // supposed to be in role service file
  getDomesticStaffCat: async function () {
    return await axiosAuthInstance
      .get("/category", {
        params: { type: "domestic_staff" },
      })
      .then((res) => {
        return res.data;
      });
  },

  getMyMetrics: async function () {
    return await axiosAuthInstance.get("/metrics").then((res) => {
      return res.data;
    });
  },

  getUsersMetrics: async function () {
    return await axiosAuthInstance.get("/metrics/users").then((res) => {
      return res.data;
    });
  },

  addUserRole: async function (input) {
    return await axiosAuthInstance
      .post("/workers", {
        phoneNumber: input.phoneNumber,
        firstName: input.firstName,
        lastName: input.lastName,
        email: input.email === "" ? null : input.email,
        gender: input.gender,
        role: input.role,
        username: input.username === "" ? null : input.username,
        communityId: communityId,
        categoryId: input.categoryId === "" ? null : input.categoryId,
      })
      .then((res) => {
        return res.data;
      });
  },

  editUserRole: async function (input, roleId) {
    const payload = {
      phoneNumber: input.phoneNumber,
      firstName: input.firstName,
      lastName: input.lastName,
      email: input.email === "" ? null : input.email,
      gender: input.gender,
      role: input.role,
      username: input.username === "" ? null : input.username,
      communityRoleId: roleId,
      domesticStaff: {
        categoryId: input.categoryId,
      },
    };
    input.role !== "domestic_staff" && delete payload["domesticStaff"];
    return await axiosAuthInstance
      .put(`/workers/${roleId}`, payload)
      .then((res) => {
        return res.data;
      });
  },

  getCommunities: async function () {
    return await axiosAuthInstance.get("/users/me").then((res) => {
      return res.data;
    });
  },

  findSocialUser: async function (paramPayload) {
    return await axiosAuthInstance
      .get(`/social/communities/${communityId}/members/find`, {
        params: paramPayload,
      })
      .then((res) => {
        return res.data;
      });
  },

  findCommunityMember: async function (paramPayload) {
    return await axiosAuthInstance
      .get(`/communities/${communityId}/members/find`, {
        params: paramPayload,
      })
      .then((res) => {
        return res.data;
      });
  },

  getRoleStats: async function () {
    return await axiosAuthInstance.get("/users/me").then((res) => {
      return res.data;
    });
  },

  getRoles: async function (input) {
    return await axiosAuthInstance
      .get("/workers", {
        params: {
          page: input.page,
          pageSize: input.pageSize,
          communityId: communityId,
          query: input.query,
          sortBy: input.sortBy,
          sortOrder: input.sortOrder,
          status:input.status
        },
      })
      .then((res) => {
        return res.data;
      });
  },

  resendInvite: async function (id) {
    return await axiosAuthInstance
      .post(`/workers/${id}/resend-invitation`)
      .then((res) => {
        return res.data;
      });
  },

  submitProfile: async function (input) {
    return await axiosAuthInstance
      .post("users/me/profile", input)
      .then((res) => {
        return res.data;
      });
  },

  updateProfile: async function (input) {
    return await axiosAuthInstance.patch("users/me", input).then((res) => {
      return res.data;
    });
  },

  updateProfilePicture: async function (file) {
    return await axiosAuthInstance.put("users/me/avatar", file).then((res) => {
      return res.data;
    });
  },

  updateBannerImage: async function (file) {
    return await axiosAuthInstance.put("users/me/banner", file).then((res) => {
      return res.data;
    });
  },

  deactivateAccount: async function (id, reason) {
    return await axiosAuthInstance
      .post(`/workers/${id}/deactivate`, { reason: reason })
      .then((res) => {
        return res.data;
      });
  },

  activateAccount: async function (id) {
    return await axiosAuthInstance
      .post(`/workers/${id}/reactivate`)
      .then((res) => {
        return res.data;
      });
  },

  initiateNationalIdChange: async function () {
    return await axiosAuthInstance.post(
      "/users/me/national-id/change/initiate"
    );
  },

  confirmNationalIdChange: async function (input) {
    return await axiosAuthInstance.post(
      "/users/me/national-id/change/confirm",
      { ...input }
    );
  },

  // block user
  blockWorker: async function (payload) {
    return await axiosAuthInstance
      .post("/users/block", { userId: payload.userId, reason: payload.reason })
      .then((res) => {
        return res.data;
      });
  },

  // unblock user
  unblockWorker: async function (payload) {
    return await axiosAuthInstance
      .post("/users/unblock", {
        userId: payload.userId,
        reason: payload.reason,
      })
      .then((res) => {
        return res.data;
      });
  },
};

export default UserService;
